// Module
var code = "<select class=\"form-control\" ng-model=\"model\" ng-options=\"country[0] as country[1] for country in countries\"><option value=\"\"></option></select>\n";
// Exports
module.exports = code;